import Vue from 'vue'
import Vuex from 'vuex'

require('es6-promise').polyfill()

Vue.use(Vuex)

import * as actions from './actions'
import home from './modules/home'
import sport from './modules/sport'
import account from './modules/account'
import breadcumb from './modules/breadcumb'
import sportOdds from './modules/sport-odds'
import allBet from './modules/all-bet'
import help from './modules/help'
import bettingForm from './modules/betting-form'
import result from './modules/result'
import sportLeague from './modules/sport-league'

export default new Vuex.Store({
  actions,
  modules: [
    account,
    sport,
    sportOdds,
    home,
    breadcumb,
    allBet,
    help,
    bettingForm,
    result,
    sportLeague,
  ]
})



// WEBPACK FOOTER //
// ./resources/score/vue/store/index.js